// utils/localStorage/loanTooltipFields.js

const STORAGE_KEY = "loanTooltipCustomFields";

/**
 * Get custom fields from localStorage
 * @returns {Array} Array of custom field objects { dataKey, label }
 */
export const getCustomTooltipFields = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];
    return JSON.parse(stored);
  } catch (error) {
    console.error(
      "Error reading custom tooltip fields from localStorage:",
      error,
    );
    return [];
  }
};

/**
 * Save custom fields to localStorage
 * @param {Array} fields - Array of custom field objects { dataKey, label }
 */
export const saveCustomTooltipFields = (fields) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(fields));
    return true;
  } catch (error) {
    console.error("Error saving custom tooltip fields to localStorage:", error);
    return false;
  }
};

/**
 * Clear custom fields from localStorage
 */
export const clearCustomTooltipFields = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
    return true;
  } catch (error) {
    console.error(
      "Error clearing custom tooltip fields from localStorage:",
      error,
    );
    return false;
  }
};
